import type {
  LoginPayload,
  TrackingEvent,
  TrackingPayload,
} from '~/types/tracking'

const useLoginErrorEvent = (
  track: (event: TrackingEvent, payload: TrackingPayload) => void,
) => {
  return {
    trackLoginError: async (trackableObject: LoginPayload) => {
      const payloadData = {
        method: trackableObject.method,
        status: trackableObject.status,
        category: trackableObject.category,
        action: trackableObject.action,
        label: `${trackableObject.method} ${trackableObject.status}`,
      }

      track('login_error', {
        ...payloadData,
      })
    },
  }
}

export default useLoginErrorEvent
